import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function WeddingDateInquiry() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-ivory relative overflow-hidden" data-id="element-164">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-165">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-saffron/5 rounded-full blur-3xl" data-id="element-166" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-167" />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-marble border border-gold/20 p-10 md:p-16 rounded-sm text-center shadow-sm" data-id="element-169">
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-4" data-id="element-170">
            {t('weddingDateInquiry.title')}
          </h2>
          <p className="text-saffron font-medium text-lg mb-6" data-id="element-171">
            {t('weddingDateInquiry.subtitle')}
          </p>
          <p className="text-navy/70 text-lg leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-172">
            {t('weddingDateInquiry.description')}
          </p>

          <div className="flex flex-col items-center justify-center" data-id="element-173">
            <a href="https://wa.me/6596670750" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 bg-[#25D366] text-white rounded-sm text-sm tracking-widest uppercase font-semibold hover:bg-[#128C7E] transition-colors duration-300 shadow-md hover:shadow-lg mb-4" data-id="element-174">
              <MessageCircleIcon className="w-5 h-5 mr-3" data-id="element-175" />
              {t('weddingDateInquiry.cta')}
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}